// =====================================================================
// COMPONENT: quiz-recent-list.component.ts
// FUNCTIONAL OVERVIEW:
//   "Recent Quizzes" list shown in the sidebar History section while the
//   Quiz menu is active. Each item is a quiz chat: its name (with the
//   number of quizzes when it holds several) and start date; selecting
//   one emits its chat_session_id. Presentational only.
// DEPENDENCIES: none
// =====================================================================
import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { QuizHistoryItem } from '../../../../models/quiz/quiz-api.models';

@Component({
  selector: 'app-quiz-recent-list',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './quiz-recent-list.component.html',
  styleUrl: './quiz-recent-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuizRecentListComponent {
  readonly items = input<QuizHistoryItem[]>([]);
  readonly loading = input(false);
  readonly selectedId = input<number | null>(null);
  readonly open = output<number>();

  // -----------------------------------------------------------------
  // METHOD PURPOSE:
  //   Item label: chat name, plus the quiz count for multi-quiz chats.
  //
  // MODIFICATION HISTORY (latest first – keep ONLY the last 3):
  //   [JHUD-5314] 2026-10-29 21:00 | Vikas Kumar | Label quiz chats from the grouped history.
  // -----------------------------------------------------------------
  label(item: QuizHistoryItem): string {
    return item.quiz_count > 1 ? `${item.chat_name} · ${item.quiz_count} quizzes` : item.chat_name;
  }
}
